import defaultFields from 'store/Services/fields';
import { updatePreferences } from 'store/Preferences/actions';
import { selectServicesFields } from './selectors';
import { cloneDeep } from 'lodash';

export function setFieldVisibility (field, value) {
  return async (dispatch, getState) => {
    let services_table = cloneDeep(selectServicesFields(getState()));

    if (!services_table) services_table = { ...defaultFields };

    if (!services_table[field].locked) {
      services_table[field].visible = value;

      if (value) {
        services_table[field].order = Object.keys(services_table).filter(key => services_table[key].visible).length;
      } else {
        let cont = 1;
        Object.keys(services_table)
          .filter(f => services_table[f].visible && f !== field)
          .sort((a, b) => (services_table[a].order - services_table[b].order))
          .forEach(f2 => {
            services_table[f2].order = cont;
            cont++;
          });
      }

      dispatch(updatePreferences({ services_table }));
    }
  };
}

export function setNewOrderColumns (columns) {
  return async (dispatch, getState) => {
    let services_table = cloneDeep(selectServicesFields(getState()));

    if (!services_table) services_table = { ...defaultFields };

    const fixedColumnsCount = Object.values(services_table).filter(col => col.locked).length;

    columns.forEach((column, index) => {
      if (column && !services_table[column].locked) {
        services_table[column].order = index + 1 + fixedColumnsCount;
      }
    });

    dispatch(updatePreferences({ services_table }));
  };
}

export function resetDefault () {
  return async (dispatch) => {
    dispatch(updatePreferences({ services_table: defaultFields }));
  };
}
